import { Api, AppRouters } from "settings";
import {
  isAllKeyNullOrUndefined,
  isEmptyString,
  isNullOrUndefined,
  isSuccessResponse,
} from "shared";
import eventBus from "service/eventBus";
import http from "service/api";
import { ModalEvents } from "components/style-guide/modal/ModalEvents";
import { SuccessMessageContent } from "components/style-guide/modal/components/SuccessMessage/SuccessMessageContent";
import React from "react";
import { navigate } from "@reach/router";
import { MessageSentContent } from "components/style-guide/modal/components/MessageSent/MessageSentContent";
import { ErrorMessageContent } from "components/style-guide/modal/components/ErrorMessage/ErrorMessageContent";
import { ModalHelper } from "shared/modal";
import { ConfirmMessageContent } from "components/style-guide/modal/components/ConfirmMessage/ConfirmMessageContent";
import { StorageService } from "service/storage";
import { UtilConst } from "settings/data";

export const updatePaymentTypeAction = (payload) => ({
  type: "UPDATE_PAYMENT_TYPE",
  payload,
});
export const updateBillInfoAction = (payload) => ({
  type: "UPDATE_BILL_INFO",
  payload,
});
export const deleteBillInfoAction = () => ({ type: "DELETE_BILL_INFO" });
export const paymentSelectedIsDirtyAction = (payload) => ({
  type: "PAYMENT_SELECTED_IS_DIRTY",
  payload,
});
export const generalDataIsDirtyAction = (payload) => ({
  type: "GENERAL_DATA_STEP_IS_DIRTY",
  payload,
});
export const disableIsDirty = () => ({ type: "DISABLE_IS_DIRTY" });
export const updateGeneralDataAction = (payload) => ({
  type: "UPDATE_GENERAL_DATA",
  payload,
});
export const resetStateAction = () => ({ type: "NEW_REPORT_RESET" });
export const setGeneralDataErrors = (payload) => ({
  type: "SET_GENERAL_DATA_ERRORS",
  payload,
});
export const newReportPatchStateAction = (payload) => ({
  type: "NEW_REPORT_PATCH_STATE",
  payload,
});
export const newReportUpdateNestedPropAction = (prop, value) => ({
  type: "NEW_REPORT_UPDATE_NESTED_PROP",
  prop,
  value,
});

export const syncCurrentReport = (reportId) => {
  return async (dispatch, getState) => {
    if (!reportId) return;

    try {
      const response = await http.get(Api.getRequestEndPoint(reportId));

      if (!isSuccessResponse(response) || !response.data.success) {
        await navigate(AppRouters.expiredPaymentError, { replace: true });
        return;
      }

      const payload = {
        syncPending: true,
        reportPayload: { ...response.data.result, uuid: reportId },
      };

      dispatch(newReportPatchStateAction(payload));
      dispatch(pushNewReport(payload.reportPayload, AppRouters.myReports));
    } catch (e) {
      console.log(e);
      eventBus.dispatch(ModalEvents.OPEN, {
        content: <ErrorMessageContent />,
        className: "empty-modal-title",
      });
      await navigate(AppRouters.myReports, { replace: true });
    }
  };
};

export const pushNewReport = (payload, redirectTo = "") => {
  return async (dispatch, getState) => {
    const state = getState();

    dispatch(newReportPatchStateAction({ finished: true }));

    try {
      const auth = state.authReducers;
      if (auth.isAuthenticated) {
        const referral_code = StorageService.getItem(UtilConst.ls_referral_code);
        if (referral_code) {
          payload.referral = referral_code;
        }
        const response = await http.post(Api.generateNewReport, payload);
        if (isSuccessResponse(response)) {
          StorageService.removeItem(UtilConst.ls_referral_code);
          navigate(AppRouters.myReports, { replace: true }).then(() => {
            ModalHelper.open(
              null,
              <SuccessMessageContent
                onAcceptAction={() => {
                  eventBus.dispatch(ModalEvents.CLOSE);
                  window.location.assign(response.data.result);
                }}
              />,
              () => {
                eventBus.dispatch(ModalEvents.CLOSE);
                window.location.assign(response.data.result);
              },
              { className: "empty-modal-title" }
            );
          });

          return;
        }
        // call service to authenticate the user with the email provided
      } else {
        const response = await http.post(Api.saveRequestEndPoint, payload);

        if (isSuccessResponse(response)) {
          return eventBus.dispatch(ModalEvents.OPEN, {
            content: <MessageSentContent target={payload.email} />,
            className: "empty-modal-title",
          });
        }
      }
    } catch (e) {
      console.log(e);
    }

    dispatch(newReportPatchStateAction({ finished: false }));
    eventBus.dispatch(ModalEvents.OPEN, {
      content: <ErrorMessageContent />,
      className: "empty-modal-title",
    });

    if (redirectTo !== "") {
      await navigate(redirectTo, { replace: true });
    }
  };
};

const isEmptyReport = (reportState) => {
  return (
    isAllKeyNullOrUndefined(reportState.billInfo) &&
    isAllKeyNullOrUndefined(reportState.generalData, ["patentes"]) &&
    isNullOrUndefined(reportState.paymentType) &&
    isNullOrUndefined(reportState.generalData.patentes[0].patente)
  );
};

export const checkNewReportStatus = ({ navigateTo }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const reportState = state.newReportReducers.data;

    if (isEmptyReport(reportState)) {
      await navigate(navigateTo);
      return;
    }

    ModalHelper.open(
      null,
      <ConfirmMessageContent
        title="¿Seguro que desea continuar?"
        message="Los datos ingresados en la solicitud se perderán."
        onCancelAction={ModalHelper.close}
        onAcceptAction={async () => {
          await navigate(navigateTo);
          ModalHelper.close();
          dispatch(resetStateAction());
        }}
      />,
      null,
      { className: "empty-modal-title" }
    );
  };
};

export const cancelNewReportAction = (generalData) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const auth = state.authReducers;
  const report = state.newReportReducers;

  if (
    !isEmptyString(generalData.email) &&
    !isEmptyString(generalData.recaptcha)
  ) {
    const { email, rut, phone, name, recaptcha } = generalData;
    const request = {
      email,
      rut,
      phone,
      name_lastname: name,
      profile: false,
      recaptcha,
      origin: "IDAR",
    };

    try {
      // await http.put(Api.saveMarketingUserData, request);
    } catch (e) {}
  }

  if (auth.isAuthenticated) {
    await navigate(AppRouters.myReports);
  } else {
    await navigate(AppRouters.home);
  }

  dispatch(resetStateAction());
};
